export const ADD_USER = "ADD_USER";
export const GET_USERS = "GET_USERS";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
